<template>
  <div>
    <v-card flat color="transparent" class="mt-7">
      <v-toolbar class="bdr secondary2light" :elevation="0" outlined>
        <v-toolbar-title>{{ $t("animal.genotypeData") }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <!-- <v-btn
                icon
                large
            >
            <v-icon>mdi-cog-outline</v-icon>
            </v-btn> -->
      </v-toolbar>
    </v-card>
    <v-card flat class="mt-7">
      <v-card-text>
        <geno-type /> 
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import GenoTypeData from "./genotype/GenoTypeData.vue";

export default {
  components: {
    "geno-type": GenoTypeData,
  },
  mounted() {},
  data() {
    return {
      animal: {},
      tab: null,
    };
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
</style>
